<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="css">
  @import '../static/vendor-css/bootstrap.min.css';
  @import '../static/vendor-css/all.min.css';
  @import '../static/vendor-css/font.css';
  @import '../static/vendor-css/swiper.min.css';
  @import '../static/vendor-css/style.css';
</style>



// WEBPACK FOOTER //
// src/App.vue